import {
  shareGeneric,
} from './sharing.js';

/**
* Add event handlers to elements on the page.
*/
function addEvents() {
  const shareButtonNav = document.getElementById('share-button-nav');
  shareButtonNav.addEventListener('click', async () => {
    shareGeneric(shareButtonNav);
  });
}

/**
* Init for everything to start running.
*/
function init() {
  addEvents();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
